import { Link } from 'react-router-dom';

const details = [
  ['Haircuts', '/women-haircut-in-isro-layout/'],
  ['Hair colour', '/women-hair-colouring-in-isro-layout/'],
  ['Hair treatments', '/women-hair-treatments-in-isro-layout/'],
  ['Facials', '/best-facial-salon-in-isro-layout/'],
  ['Nail art', '/nail-art-salon-in-isro-layout/'],
];
export function ServiceLinks() {
  return <nav className="service-detail-links" aria-label="Explore services and booking">
    <h2>Explore services and book</h2>
    <div>{details.map(([label, path]) => <Link key={path} to={path}>{label}</Link>)}</div>
    <p><Link to="/charlie-guys-unisex-salon-location/">Visit our ISRO Layout salon for booking, hours and directions</Link></p>
  </nav>;
}
